import { http } from '@/lib'

export type BankName = {
  code: string
  key: string
  name: string
  swiftBic: string
  type: string | null
}

export type BankNameResponse = BankName[]

export async function getBankNameService(query: {
  countryCode?: string
  iban?: string
  swiftbic?: string
  clabe?: string
}) {
  return http
    .get<BankNameResponse>('/bank', { params: query })
    .then((res) => res.data[0] ?? [])
}

export async function getBanksService(query: { countryCode: string }) {
  return http
    .get<BankNameResponse>('/bank', { params: query })
    .then((res) => res.data ?? [])
}
